// extracted by mini-css-extract-plugin
export default {"banner":"ChannelDetails_banner__KYu-N"};